<template>
	<panel-wrapper content-class="box-wap">
		<template slot="name">
			转场
		</template>
		<div :class="['button-grid', 'has-per-row-1', 'overflow-y-auto','box-wap-box']">
			<template
				v-if="allTransitions"
				class="transitions"
			>
		<!-- 		<el-button
				
	
				:class="[transition.name === currentTransition ? 'is-active' : 'is-inactive']"
				
				:type="transition.name === currentTransition ? 'primary' : 'default'"
				>{{ transition.name }}</el-button> -->
				
				
				<div
				v-for="transition in allTransitions"
				:key="transition.name"
				class="button buttonwap"
				:class="[transition.name === currentTransition ? 'button-active' : '']"
				@click="switchTransitions(transition.name)">
					
					<div>
						{{ transition.name }}
					</div>
				</div>
				<div class="background-content" v-if='showimgTitles'>
					转 场
					
				</div>
				
			</template>
			<template v-else>
				专场列表为空！应该最少有“裁切”和“渐变”。。。有点不对劲 :(
			</template>
		</div>

	</panel-wrapper>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import panelMixin from '@/mixins/panel'

export default {

	mixins: [panelMixin],

	computed: {
		...mapState(['showimgTitles']),
		...mapState('obs', {
			currentTransition: state => state.transitions.current,
			allTransitions: state => state.transitions.list
		})
	},

	methods: {
		async switchTransitions(name) {
			await this.setTransition({name})
		},
		...mapActions('obs', {
			setTransition: 'transitions/current'
		})
	}
}

</script>

<style type="text/css">

</style>
